import { cloneElement, Component } from "react"
import PropTypes from "prop-types"
import "./style.scss"

export default class Tooltip extends Component {
  static propTypes = {
    subscribe: PropTypes.func.isRequired,
    unsubscribe: PropTypes.func.isRequired,
    findByOffset: PropTypes.func.isRequired,
    legendRef: PropTypes.object,
    position: PropTypes.string,
  }

  constructor(...args) {
    super(...args)

    this.state = { showToolTip: false }
  }

  mouseMove = ({ showToolTip, nativeEvent }) => {
    this.setState({ showToolTip, nativeEvent })
  }

  componentDidMount() {
    this.props.subscribe(this.mouseMove)
  }

  componentWillUnmount() {
    this.props.unsubscribe(this.mouseMove)
  }

  tooltipRef = null

  registerTooltipRef = element => { this.tooltipRef = element }

  render() {
    const { showToolTip, nativeEvent } = this.state
    const { position, legendRef } = this.props

    if (showToolTip) {
      const { pageX, offsetX, pageY, maxX, offsetY } = nativeEvent
      // Don't show if pointer is in legend
      const legendHeight = legendRef ? legendRef.offsetHeight : 0
      if (position === "right" && offsetY < (legendHeight + 15)) {
        return null
      }

      let translateX = 0
      let translateY = 0

      if (this.tooltipRef) {
        if (position === "right") {
          translateX = 10
          if (maxX - pageX < 300) {
            translateX = -(this.tooltipRef.offsetWidth + 10)
          }
        } else {
          translateX = -(this.tooltipRef.offsetWidth / 2)
          if (offsetX < 75) {
            translateX = 0
          } else if (maxX - pageX < 75) {
            translateX = -this.tooltipRef.offsetWidth
          }
        }

        const distanceToTop = this.tooltipRef.offsetTop - (this.tooltipRef.offsetHeight + 10)

        if (distanceToTop < 0) {
          translateY = -(this.tooltipRef.offsetHeight + 10) - distanceToTop
        } else {
          translateY = -(this.tooltipRef.offsetHeight + 10)
        }
      }

      const style = {
        top: pageY,
        visibility: this.tooltipRef && offsetY > legendHeight ? "visible" : "hidden",
        left: offsetX > 75 ? pageX : pageX - offsetX,
        transform: `translate(${translateX}px,${translateY}px)`,
      }

      const { findByOffset, children } = this.props
      const datum = findByOffset(offsetX)
      if (datum) {
        return (
          <div style={style} ref={this.registerTooltipRef} className="components_charts_tooltip">
            {cloneElement(children, { datum })}
          </div>
        )
      }
    }

    return null
  }
}
